import React, { useContext, useState } from "react";
import { Layout, Menu, Tooltip } from "antd";
import { Route, Routes, Navigate, useNavigate } from "react-router-dom";
import TemplateTable from "../pages/TemplateTable";
import TemplatePointsTable from "../pages/TemplatePointsTable";
import UserTable from "../pages/UserTable";
import DepartmentTable from "../pages/DepartmentTable";
import MeetingTypeTable from "../pages/MeetingTypeTable";
import Settings from "../pages/Settings";
import GlobalContext from "../utils/GlobalContext";
import TemplateDetails from "../pages/TemplateDetails";
import MeetingTable from "../pages/MeetingTable";
import ClosedMeetingListTable from "../pages/lists/ClosedMeetingList";
import ActionListTable from "../pages/lists/ActionList";
import DecisionListTable from "../pages/lists/DecisionListTable";
import InfoListTable from "../pages/lists/InfoListTable";
import MeetingDetails from "../pages/MeetingDetails";
import MeetingExecute from "../pages/MeetingExecute";
import FollowupTable from "../pages/FollowupTable";
import OpenActionsTable from "../pages/reports/OpenActionsTable";
import ClosedActionsTable from "../pages/reports/ClosedActionsTable";
import OpenDecisionTable from "../pages/reports/OpenDecisionTable";
import ClosedDecisionTable from "../pages/reports/ClosedDecisionTable";
import ClosedInfoTable from "../pages/reports/ClosedInfoTable";
import SummaryDecisionTable from "../pages/reports/SummaryDecisionTable";
import SummaryActionTable from "../pages/reports/SummaryActionTable";
import System from "../pages/System";
import OpenInfoTable from "../pages/reports/OpenInfoTable";
import SummaryActionList from "../pages/lists/SummaryActionList";
import SummaryDecisionList from "../pages/lists/SummaryDecisionList";
import LogTable from "../pages/LogTable";

import {
  LogoutOutlined,
  SettingOutlined,
  UserOutlined,
  LayoutOutlined,
  ApartmentOutlined,
  ProfileOutlined,
  PartitionOutlined,
  BankOutlined,
  CalendarOutlined,
  ToolOutlined,
  CheckCircleOutlined,
  OrderedListOutlined,
  InfoCircleOutlined,
  FileDoneOutlined,
  FileUnknownOutlined,
} from "@ant-design/icons";

const { Sider, Content } = Layout;

const SidebarLayout = ({ onLogout }) => {
  const navigate = useNavigate();
  const globals = useContext(GlobalContext);
  const userEmail = globals.userEmail;
  const userRole = globals.userRole;
  const [collapsed, setCollapsed] = useState(true);

  const items = [
    { key: "meetings", icon: <CalendarOutlined />, label:"Reuniones" },
    { key: "followup", icon: <CheckCircleOutlined />, label: "Seguimiento" },
    {
      key: "lists",
      icon: <OrderedListOutlined />,
      children: [
        { key: "closedmeetinglist", icon: <CalendarOutlined />, label: <Tooltip title="Reuniones cerradas">Reuniones cerradas</Tooltip> },
        { key: "actionslist", icon: <FileDoneOutlined />, label: <Tooltip title="Acciones cerradas con acuerdo">Acciones cerradas con acuerdo</Tooltip> },
        { key: "decisionlist", icon: <FileUnknownOutlined />, label: <Tooltip title="Decisiones cerradas aprobadas">Decisiones cerradas aprobadas</Tooltip> },
        { key: "infolist", icon: <InfoCircleOutlined />, label: <Tooltip title="Puntos información">Puntos información</Tooltip> },
        { key: "summarydecisionlist", icon: <OrderedListOutlined />, label: <Tooltip title="Resumen de éxito decisiones">Resumen de éxito decisiones</Tooltip> },
        { key: "summaryactionlist", icon: <OrderedListOutlined />, label: <Tooltip title="Resumen de cumplimiento acciones">Resumen de cumplimiento acciones</Tooltip> },
      ],
      label: "Listados",
    },
    userRole.toLowerCase() === "admin" && {
      key: "admin",
      icon: <ApartmentOutlined />,
      children: [
        { key: "reports", 
          icon: <LayoutOutlined />, 
          children: [
            { key: "summarydecision", icon: <OrderedListOutlined />, label: <Tooltip title="Resumen de éxito decisiones">Resumen de éxito decisiones</Tooltip> },
            { key: "summaryaction", icon: <OrderedListOutlined />, label: <Tooltip title="Resumen de cumplimiento acciones">Resumen de cumplimiento acciones</Tooltip> },
            { key: "openactions", icon: <FileDoneOutlined />, label: <Tooltip title="Acciones abiertas">Acciones abiertas</Tooltip> },
            { key: "closedactions", icon: <CheckCircleOutlined />, label: <Tooltip title="Acciones cerradas">Acciones cerradas</Tooltip> },
            { key: "opendecision", icon: <FileDoneOutlined />, label: <Tooltip title="Decisiones abiertas">Decisiones abiertas</Tooltip> },
            { key: "closeddecision", icon: <CheckCircleOutlined />, label: <Tooltip title="Decisiones cerradas">Decisiones cerradas</Tooltip> },
            { key: "openinfo", icon: <InfoCircleOutlined />, label: <Tooltip title="Puntos Info. abiertos">Puntos Info. abiertos</Tooltip> },
            { key: "closedinfo", icon: <CheckCircleOutlined />, label: <Tooltip title="Puntos Info. cerrados">Puntos Info. cerrados</Tooltip> },
          ],
          label: "Reportes" 
        },
        { key: "templates", icon: <LayoutOutlined />, label: <Tooltip title="Plantillas">Plantillas</Tooltip> },
        { key: "template_points", icon: <PartitionOutlined />, label: <Tooltip title="Puntos de plantilla">Puntos de plantilla</Tooltip> },
        { key: "meeting_types", icon: <ProfileOutlined />, label: <Tooltip title="Tipos de reunión">Tipos de reunión</Tooltip> },
        { key: "departments", icon: <BankOutlined />, label: <Tooltip title="Departamentos">Departamentos</Tooltip> },
        { key: "users", icon: <UserOutlined />, label: <Tooltip title="Usuarios Externos">Usuarios Externos</Tooltip> },
        { key: "logs", icon: <CheckCircleOutlined />, label: <Tooltip title="Registros de auditoría">Registros de auditoría</Tooltip> },
        { key: "system", icon: <ToolOutlined />, label: <Tooltip title="Ajustes del sistema">Ajustes del sistema</Tooltip> },
      ],
      label: "Admin",
    },
    {
      key: "settings",
      icon: <SettingOutlined />,
      label: "Configuración",
    },
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: <Tooltip title="Salir">Salir</Tooltip>,
      style: { color: "red" },
    },
  ];

  const handleMenuClick = (menuItem) => {
    if (menuItem === "logout") {
      handleLogout();
      navigate("/");
      return;
    }
    navigate(menuItem);
  };

  const handleLogout = () => {
    onLogout();
  };

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider width={240} theme="light" collapsible collapsed={collapsed} onCollapse={toggleCollapsed}>
        <div style={{ textAlign: "center", padding: "16px" }}>
          {!collapsed && (
            <>
              <img
                src="/logo.png"
                alt="Imagen"
                style={{ height: "100px" }}
              />
              <p style={{ fontSize: "14px", color: "#888" }}>{globals.VERSION}</p>
              <Tooltip title={userEmail}>
                <p style={{ fontSize: "12px", color: "#888" }}>
                  {userEmail?.slice(0, 30)}
                </p>
              </Tooltip>
            </>
          )}
        </div>
        <div style={{ overflowY: "auto", height: "calc(100vh - 150px)" }}>
          <Menu
            onClick={({ key }) => handleMenuClick(key)}
            defaultSelectedKeys={["submission"]}
            defaultOpenKeys={["search"]}
            mode="inline"
            items={items}
          />
        </div>
      </Sider>
      <Layout>
        <Content style={{ padding: "5px", background: "#fff" }}>
          <Routes>
            <Route path="/" element={<Navigate to={'/meetings'} />} />
            <Route
              path="/meetings"
              element={<MeetingTable />}
            />
            <Route
              path="/meeting/:id"
              element={<MeetingDetails />}
            />
            <Route
              path="/meeting/:id/execute"
              element={<MeetingExecute />}
            />
            <Route
              path="/followup"
              element={<FollowupTable />}
            />
            <Route
              path="/closedmeetinglist"
              element={<ClosedMeetingListTable />}
            />
            <Route
              path="/actionslist"
              element={<ActionListTable />}
            />
            <Route
              path="/decisionlist"
              element={<DecisionListTable />}
            />
            <Route
              path="/infolist"
              element={<InfoListTable />}
            />
            <Route
              path="/summaryactionlist"
              element={<SummaryActionList/>}
            />
            <Route
              path="/summarydecisionlist"
              element={<SummaryDecisionList/>}
            />
            
            <Route 
              path="/summarydecision"
              element={<SummaryDecisionTable />}
            />
            <Route 
              path="/summaryaction"
              element={<SummaryActionTable />}
            />
            <Route 
              path="/openactions"
              element={<OpenActionsTable />}
            />
            <Route
              path="/closedactions"
              element={<ClosedActionsTable />}
            />
            <Route
              path="/opendecision"
              element={<OpenDecisionTable />}
            />
            <Route
              path="/closeddecision"
              element={<ClosedDecisionTable />}
            />
            <Route
              path="/openinfo"
              element={<OpenInfoTable />}
            />
            <Route
              path="/closedinfo"
              element={<ClosedInfoTable />}
            />
                        
            <Route
              path="/users"
              element={<UserTable userEmail={userEmail} />}
            />
            <Route
              path="/templates"
              element={<TemplateTable />}
            />
            <Route
              path="/template/:id"
              element={<TemplateDetails />}
            />
            <Route
              path="/template_points"
              element={<TemplatePointsTable />}
            />
            <Route
              path="/meeting_types"
              element={<MeetingTypeTable />}
            />
            <Route
              path="/departments"
              element={<DepartmentTable />}
            />
            <Route
              path="/logs"
              element={<LogTable />}
            />
            <Route
              path="/system"
              element={<System />}
            />
            <Route
              path="/settings"
              element={<Settings />}
            />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

export default SidebarLayout;
